// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__REzyC","VAcctTxt":"VirtualAccount_VAcctTxt__tcUP2","VFundTxt":"VirtualAccount_VFundTxt__w1MUq","VBank":"VirtualAccount_VBank__nw0yi"};